module.exports = {
      id: "cancer-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#cancer",
      toString: function () {
        return this.url;
      }
    }